// Hooks
import { useNavigateToComments } from '@/components/pages/conversations/SocialInbox/hooks/useNavigateToComments';
import { useProfileOrGroupChangeSideEffects } from '@/components/pages/conversations/SocialInbox/hooks/useProfileOrGroupChangeSideEffects';

// Components
import { PageContentWrapper } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper';
import { SocialInboxDesktop } from '@/components/pages/conversations/SocialInbox/components/SocialInboxDesktop/SocialInboxDesktop';
import { SocialInboxMobile } from '@/components/pages/conversations/SocialInbox/components/SocialInboxMobile/SocialInboxMobile';

export const SocialInbox = () => {
    useProfileOrGroupChangeSideEffects();
    useNavigateToComments();

    return (
        <PageContentWrapper>
            <div className="size-full overflow-hidden rounded-t-xl bg-icoGray-300 dark:bg-icoDarkMode-beton">
                <SocialInboxMobile />
                <SocialInboxDesktop />
            </div>
        </PageContentWrapper>
    );
};
